import { IChatFilesResponse } from '../repositories/chats/entities/file/ChatFilesResponse';
import { TGetLatestChatFilesResponse, fetchGetLatestChatFiles } from '../repositories/chats/v1/get-latest-chat-files';
import { TContext } from '../types/context';
import { EExceptionDomain } from '../types/exceptionDomains';
import { getGenericLikeError } from '../utils/logging/getGenericLikeError';
import { getResponseError } from '../utils/logging/getResponseError';

type TFetchGetLatestChatFilesRequest = {
  chatId: string;
  offset: number;
};

type TFetchGetLatestChatFilesParams = {
  parameters: TFetchGetLatestChatFilesRequest;
  cookies?: string;
};

const DEFAULT_ERROR_MESSAGE = 'Ошибка при получении файлов чата';

export async function fetchChatImages(
  { logger, httpApi }: TContext,
  { cookies, parameters }: TFetchGetLatestChatFilesParams,
) {
  try {
    const { response, statusCode }: TGetLatestChatFilesResponse = await fetchGetLatestChatFiles({
      httpApi,
      parameters,
      config: {
        requestConfig: {
          headers: cookies ? [['Cookie', cookies]] : [],
          withCredentials: true,
        },
      },
    });

    if (statusCode !== 200) {
      throw getResponseError({
        domain: EExceptionDomain.Chat,
        response,
        defaultMessage: DEFAULT_ERROR_MESSAGE,
        statusCode,
      });
    }

    return response as IChatFilesResponse;
  } catch (error) {
    const exception = getGenericLikeError({
      error,
      domain: EExceptionDomain.Chat,
      message: DEFAULT_ERROR_MESSAGE,
    });

    logger.error(exception, {
      microserviceName: 'chats',
      pathApi: '/v1/get-latest-chat-files/',
      parameters: JSON.stringify(parameters),
    });

    return null;
  }
}
